
export default function FormHeaderLab({ taskParams }) {

  return (
    <>
      {['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status) ?
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3">
                  <h6>Задание отправлено на проверку</h6>
                </div>
              </div>
            </div>   
          </>
        )
      :
        ( 
          <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '30px'}}>
            <div className='col-9 ps-0'>
              <div className="form-head p-3">
                <h6>Цикл: <b>{taskParams.form?.cycle}</b></h6>
                <h6>Представление результатов до: <b>{taskParams.deadline_date}</b></h6>
                <h6>Номера ОПК: {taskParams.samples}</h6> 
              </div>
            </div>
          </div> 
        )
      }

      {taskParams.status === 'PENDING' &&
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3">
                  <h6><span className="text-danger fw-bold">Задание станет доступно для редактирования начиная с {taskParams.start_date}</span></h6>
                </div>
              </div>
            </div>   
          </>
        )
      }      
    </>
  )
}